import React from 'react'
import { useIntl } from 'react-intl'

import Link from 'next/link'
import Button from 'src/comps/Atom/Buttons/Button'
import SearchIcon from 'client/icons/Search'

import { useSearch } from 'src/hooks/useSearch'
import { SearchUrl } from 'src/types/search'

export interface ISearchButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  fullWidth: boolean
  preventNavigation: boolean
  searchUrl: SearchUrl
  small?: boolean
}

const SearchButton = ({
  onClick,
  fullWidth = false,
  preventNavigation = false,
  searchUrl,
  small = false,
}: ISearchButtonProps) => {
  const intl = useIntl()
  const { draftLocation, setShowSuggesterError } = useSearch()
  const { href, shallow } = searchUrl
  const canSearch = !!draftLocation

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!canSearch) {
      event.preventDefault()
      setShowSuggesterError(true)
      return
    }
    onClick(event)
  }

  return (
    <Link href={href} passHref shallow={shallow && preventNavigation}>
      <Button
        as="a"
        size="m"
        backgroundColor="brand1"
        borderColor="brand1"
        color="grey8"
        type="button"
        leftIcon={<SearchIcon size={20} />}
        fullWidth={fullWidth}
        onClick={handleClick}
        data-testid="search-button"
      >
        {!small && (
          <span data-testid="search-button-text" className="buttonText">
            {intl.formatMessage({ id: 'global.search' })}
          </span>
        )}
      </Button>
    </Link>
  )
}

export default SearchButton
